"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.issueResolutionTimeLabel = exports.issueResolutionTimeColor = exports.IssueResolutionTimes = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
// eslint-disable-next-line no-shadow
var IssueResolutionTimes;
(function (IssueResolutionTimes) {
    IssueResolutionTimes["LESSTHANADAY"] = "lessthanaday";
    IssueResolutionTimes["ONETO3DAYS"] = "oneto3days";
    IssueResolutionTimes["THREEDAYSTO1WEEK"] = "3daysto1week";
    IssueResolutionTimes["ONEWEEKTOTWOWEEKS"] = "1weekto2weeks";
    IssueResolutionTimes["TWOWEEKSTOONEMONTH"] = "2weeksto1month";
    IssueResolutionTimes["MORETHANAMONTH"] = "morethanamonth";
    IssueResolutionTimes["UNRESOLVED"] = "unresolved";
})(IssueResolutionTimes = exports.IssueResolutionTimes || (exports.IssueResolutionTimes = {}));
exports.default = IssueResolutionTimes;
function issueResolutionTimeColor(status) {
    switch (status) {
        case IssueResolutionTimes.LESSTHANADAY:
            return lib_palette_1.default.GoodGreen;
        case IssueResolutionTimes.ONETO3DAYS:
            return lib_palette_1.default.Greeny;
        case IssueResolutionTimes.THREEDAYSTO1WEEK:
            return lib_palette_1.default.GoodOldBlue;
        case IssueResolutionTimes.ONEWEEKTOTWOWEEKS:
            return lib_palette_1.default.MellowYellow;
        case IssueResolutionTimes.TWOWEEKSTOONEMONTH:
            return lib_palette_1.default.OJ;
        case IssueResolutionTimes.MORETHANAMONTH:
            return lib_palette_1.default.BadRed;
        case IssueResolutionTimes.UNRESOLVED:
            return lib_palette_1.default.BlackCoral;
        default:
            return lib_palette_1.default.GreyBlue;
    }
}
exports.issueResolutionTimeColor = issueResolutionTimeColor;
function issueResolutionTimeLabel(status) {
    switch (status) {
        case IssueResolutionTimes.LESSTHANADAY:
            return lib_i18n_1.default.t('lessthanaday');
        case IssueResolutionTimes.ONETO3DAYS:
            return lib_i18n_1.default.t('oneto3days');
        case IssueResolutionTimes.THREEDAYSTO1WEEK:
            return lib_i18n_1.default.t('3daysto1week');
        case IssueResolutionTimes.ONEWEEKTOTWOWEEKS:
            return lib_i18n_1.default.t('1weekto2weeks');
        case IssueResolutionTimes.TWOWEEKSTOONEMONTH:
            return lib_i18n_1.default.t('2weeksto1month');
        case IssueResolutionTimes.MORETHANAMONTH:
            return lib_i18n_1.default.t('morethanamonth');
        case IssueResolutionTimes.UNRESOLVED:
            return lib_i18n_1.default.t('unresolved');
    }
}
exports.issueResolutionTimeLabel = issueResolutionTimeLabel;
